import React from 'react';
import { Spinner, ErrorBanner } from '../ReportTableKit';

export const VOUCHER_COLUMNS = [
  ['id', 'ID'], ['lms_id', 'LMS ID'], ['student_name', 'Student Name'], ['student_email', 'Student Email'],
  ['course_title', 'Course Name'], ['course_code', 'Course Code'], ['solution_area', 'Solution Area'],
  ['partner_one_id', 'Partner One ID'], ['partner_name', 'Partner Name'], ['user_type', 'Type'],
  ['domain_type', 'Domain Type'], ['platform_type', 'Platform Type'], ['domain', 'Domain'], ['region', 'Region'],
  ['enrolled_at', 'Enrolled At'], ['completion_date', 'Completed At'], ['assigned_at', 'Assigned Date'],
  ['expiry_date', 'Expiry Date'], ['campaign', 'Campaign'], ['voucher_type', 'Voucher Type'],
  ['voucher_code', 'Voucher Code'], ['batch_id', 'Batch'], ['email_sent', 'Email Sent'],
  ['sent_type', 'Sent Type'], ['status', 'Status'],
];
const WIDE = { course_title: 260, student_email: 220, partner_name: 200, campaign: 220 };

const STATUS_COLORS = { assigned: ['#dcfce7', '#15803d'], pending: ['#fef9c3', '#a16207'], expired: ['#fee2e2', '#b91c1c'], disabled: ['#f1f5f9', '#64748b'] };

function Cell({ k, v, onLearner }) {
  if (k === 'lms_id' && v) {
    return (
      <button onClick={() => onLearner(v)} data-testid={`voucher-lms-link-${v}`}
        style={{ background: 'none', border: 'none', padding: 0, color: '#4338ca', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline', fontSize: 12 }}>
        {v}
      </button>
    );
  }
  if (k === 'status') {
    const [bg, fg] = STATUS_COLORS[String(v || '').toLowerCase()] || STATUS_COLORS.disabled;
    return <span style={{ padding: '2px 8px', borderRadius: 999, fontSize: 11, fontWeight: 600, background: bg, color: fg }}>{v || '—'}</span>;
  }
  if (v === null || v === undefined || v === '') return <span style={{ color: '#cbd5e1' }}>—</span>;
  return v;
}

export function VoucherTable({ rows, loading, error, onLearner }) {
  if (loading) return <div className="table-container"><Spinner /></div>;
  if (error) return <ErrorBanner message={error} testId="voucher-error" />;
  if (!rows.length) return (
    <div className="table-container"><div className="empty-state" data-testid="voucher-empty"><h3>No voucher issuance found</h3></div></div>
  );
  return (
    <div className="table-container">
      <div className="table-scroll" style={{ maxHeight: '68vh', overflowY: 'auto' }}>
        <table data-testid="voucher-table">
          <thead><tr>{VOUCHER_COLUMNS.map(([k, l]) => <th key={k} style={{ whiteSpace: 'nowrap', zIndex: 1 }}>{l}</th>)}</tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id} data-testid={`voucher-row-${i}`}>
                {VOUCHER_COLUMNS.map(([k]) => (
                  <td key={k} style={{ fontSize: 12, minWidth: WIDE[k], whiteSpace: WIDE[k] ? 'normal' : 'nowrap' }}>
                    <Cell k={k} v={r[k]} onLearner={onLearner} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
